import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('alphaWithSpaces', /^[a-zA-Z\s]*$/);
